import type { TableCellBorders } from './table-types'

export const TABLE_CELL_DIVIDER = {
  afterBg: 'after:bg-zinc-500/6',
  beforeBg: 'before:bg-zinc-500/6'
} as const

const TABLE_COL_DIVIDER_BASE =
  "before:pointer-events-none before:absolute before:inset-y-0 before:right-0 before:z-[2] before:w-px before:content-['']"

/** Straight 1px column divider via ::before on the right edge of the cell */
export const TABLE_COL_DIVIDER_BEFORE = `${TABLE_COL_DIVIDER_BASE} ${TABLE_CELL_DIVIDER.beforeBg}`

const HORIZONTAL_DIVIDER_BASE =
  "after:pointer-events-none after:absolute after:bottom-0 after:z-[2] after:h-px after:content-['']"

/** Row line spans all cells; inset-x-2 only at row edges to avoid gaps between columns */
export function getHorizontalDividerClass({
  isFirstColumn,
  isLastColumn,
  colorClass
}: {
  isFirstColumn: boolean
  isLastColumn: boolean
  colorClass: string
}): string {
  if (isFirstColumn && isLastColumn) {
    return `${HORIZONTAL_DIVIDER_BASE} after:inset-x-2 ${colorClass}`
  }
  if (isFirstColumn) {
    return `${HORIZONTAL_DIVIDER_BASE} after:left-2 after:right-0 ${colorClass}`
  }
  if (isLastColumn) {
    return `${HORIZONTAL_DIVIDER_BASE} after:left-0 after:right-2 ${colorClass}`
  }
  return `${HORIZONTAL_DIVIDER_BASE} after:inset-x-0 ${colorClass}`
}

export function getCellBorderClasses({
  cellBorders,
  isFirstColumn,
  isLastColumn
}: {
  cellBorders: TableCellBorders
  isFirstColumn: boolean
  isLastColumn: boolean
}): string[] {
  if (cellBorders === 'none') return []

  const classes = ['relative']

  if ((cellBorders === 'vertical' || cellBorders === 'both') && !isLastColumn) {
    classes.push(TABLE_COL_DIVIDER_BEFORE)
  }

  if (cellBorders === 'horizontal' || cellBorders === 'both') {
    classes.push(
      getHorizontalDividerClass({
        isFirstColumn,
        isLastColumn,
        colorClass: TABLE_CELL_DIVIDER.afterBg
      })
    )
  }

  return classes
}
